import * as T from "../constants";

export const redirectToSecureKey = (payload, handleWhileLoadingSecureKeyUrl, handleErrorsWhenLoadingSecureKeyUrl) => ({
    type: T.SECURE_KEY.GET_URL,
    payload: {
        payload,
        handleWhileLoadingSecureKeyUrl,
        handleErrorsWhenLoadingSecureKeyUrl,
    }
})

export const secureKeyGetPortalVerificationDetails = (payload, props) => ({
    type: T.SECURE_KEY.VERIFICATION_FORM_DETAILS,
    payload: {
        payload,
        props
    }
})